import { IonContent } from "@ionic/react";
import HeaderComponent from "../components/HeaderComponent";
import DeviceListTable from "../components/DeviceListTable";

const Devices: React.FC = () => {
  return (
    <IonContent fullscreen>
      <HeaderComponent title={"Devices"} />
      <DeviceListTable />
    </IonContent>
  );
};

export default Devices;
